import { render, staticRenderFns } from "./homeDecoration.vue?vue&type=template&id=b09cd344&"
import script from "./homeDecoration.vue?vue&type=script&lang=js&"
export * from "./homeDecoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports